import { useEffect, useState } from "react";
import GlobalProvider from "../context/Provider";
import RouterWithSession from "./RouterWithSession";

const RouterApp = () => {
  const [jsonLeido, setJsonLeido] = useState(false);

  useEffect(() => {
    fetch(`./config.json?v=${new Date().getTime()}`)
      .then((response) => {
        return response.json();
      })
      .then((jsondata) => {
        localStorage.setItem("config", JSON.stringify(jsondata));
        setJsonLeido(true);
      });
  }, []);

  return (
    <>
      {jsonLeido && (
        <GlobalProvider>
          <RouterWithSession />
        </GlobalProvider>
      )}
    </>
  );
};

export default RouterApp;
